<template>
    <div class="app flex-row align-items-sm-center login-container-xs">
        <div class="container">
            <div class="row justify-content-center">
                <spinner v-if="!invitationKey"></spinner>
                <div v-else class="col-12 col-md-9">
                    <div class="card-group mb-0">
                        <div class="card px-4 pt-4">
                            <div class="card-body login-container">
                                <form @submit.prevent.stop="submit" v-debounce="'submit'" ref="form">
                                    <h4 class="mb-5">{{ trans('contacts.actions.register_for_jibit') }}</h4>

                                    <div class="form-group row">
                                        <div class="col-12 col-md-4 col-lg-3">
                                            <label for="user_first_name" class="col-form-label required">{{ trans('contacts.attributes.first_name') }}</label>
                                        </div>
                                        <div class="col-12 col-md-8 col-lg-9">
                                            <input type="text" id="user_first_name" v-model="user.first_name" class="form-control">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-12 col-md-4 col-lg-3">
                                            <label for="user_name" class="col-form-label required">{{ trans('contacts.attributes.surname') }}</label>
                                        </div>
                                        <div class="col-12 col-md-8 col-lg-9">
                                            <input type="text" id="user_name" v-model="user.name" class="form-control">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-12 col-md-4 col-lg-3">
                                            <label for="company_name" class="col-form-label required">{{ trans('admin.tenants.attributes.company.name') }}</label>
                                        </div>
                                        <div class="col-12 col-md-8 col-lg-9">
                                            <input type="text" id="company_name" v-model="company.name" class="form-control">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-12 col-md-4 col-lg-3">
                                            <label for="email" class="col-form-label required">{{ trans('contacts.attributes.email_address') }} /<br>{{ trans('contacts.attributes.user_name') }}</label>
                                        </div>
                                        <div class="col-12 col-md-8 col-lg-9">
                                            <input type="email" id="email" v-model="user.email" class="form-control" disabled="disabled" readonly="readonly">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-12 col-md-4 col-lg-3">
                                            <label for="password" class="col-form-label required">{{ trans('contacts.attributes.password') }}</label>
                                        </div>
                                        <div class="col-12 col-md-8 col-lg-9">
                                            <input type="password" id="password" v-model="user.password" class="form-control">
                                            <div class="help-block"><small>{{ trans('auth.hint_password') }}</small></div>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-12 col-md-4 col-lg-3">
                                            <label for="password_repetition" class="col-form-label required">{{ trans('contacts.attributes.password_repetition') }}</label>
                                        </div>
                                        <div class="col-12 col-md-8 col-lg-9">
                                            <input type="password" id="password_repetition" v-model="user.password_repetition" class="form-control">
                                        </div>
                                    </div>

                                    <div class="form-group row has-danger" v-if="hasErrorMessages">
                                        <div class="col-12">
                                            <div class="form-control-feedback" v-html="formattedErrorMessage"></div>
                                        </div>
                                    </div>
                                    <div class="form-group row has-danger" v-if="hasValidationMessages">
                                        <div class="col-12">
                                            <div class="form-control-feedback" v-html="formattedValidationMessage"></div>
                                        </div>
                                    </div>

                                    <spinner v-if="loading" slot="field"></spinner>

                                    <div class="form-group row mt-5">
                                        <div class="col-12">
                                            <button type="submit" class="btn btn-success pull-right">{{ trans('contacts.actions.register') }}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import { mapState, mapActions } from 'vuex';

    import Spinner from "../../components/Loaders/Spinner";
    import LoginController from "../../services/Auth/LoginController";
    import RegisterController from "../../services/Auth/RegisterController";
    import TenantInvitationController from "../../services/Tenants/TenantInvitationController";

    export default {
        name: 'auth-register-tenant',

        components: {
            Spinner
        },

        data() {
            return {
                loading: false,
                user: {
                    first_name: null,
                    name: null,
                    email: null,
                    password: null,
                    password_repetition: null
                },
                company: {
                    name: null
                },
                countries: [],
                invitationKey: null
            };
        },

        created() {
            this.setPageTitle(this.trans('contacts.actions.register'));

            LoginController.authCheck().then(response => {
                if (response) {
                    // Log out lazy testing users who for some reason don't log out before using this
                    this.logout();
                } else {
                    this.showForm();
                }
            });
        },

        computed: {
            ...mapState(['messages']),

            hasValidationMessages() {
                return Object.keys(this.messages.validation).length > 0;
            },

            formattedValidationMessage() {
                return Object.keys(this.messages.validation).reduce((acc, field) => {
                    return `${acc}${acc ? '<br>' : ''}${this.messages.validation[field]}`;
                }, '');
            },

            hasErrorMessages() {
                return this.messages.error.length > 0;
            },

            formattedErrorMessage() {
                return this.messages.error[0];
            }
        },

        methods: {

            ...mapActions(['swalToast', 'resetMessages', 'logoutAuthUser']),

            logout() {
                const self = this;

                this.logoutAuthUser().then(function () {
                    self.showForm();
                });
            },
            
            showForm() {
                RegisterController.showTenant(
                    this.$router.currentRoute.params.key,
                    this.$router.currentRoute.params.hash
                ).then(response => {
                    if (response.exists && response.status === 'sent') {
                        this.invitationKey = this.$router.currentRoute.params.key;
                        this.user.email = response.email;
                    } else {
                        this.$router.replace({
                            path: '/login'
                        }, () => {
                            this.swalToast({
                                type: 'error',
                                message: [this.trans('messages.error.registration.link_invalid')]
                            });
                        });
                    }
                });
            },

            submit() {
                this.formSubmitShowWait(this.$refs.form);

                this.loading = true;

                this.resetMessages();

                const params = {
                    user: this.user,
                    company: this.company
                };

                TenantInvitationController.submitRegistrationForm(this.invitationKey, params).then(response => {
                    if (response.success) {
                        this.$router.replace({
                            name: 'auth.register-tenant-done',
                            params: {
                                key: this.$router.currentRoute.params.key,
                                hash: this.$router.currentRoute.params.hash
                            }
                        });
                    } else {
                        this.swalToast({
                            type: 'error',
                            message: [this.trans('messages.error.registration.error_occurred')]
                        });
                        this.loading = false;
                    }
                }).catch(() => {
                    this.loading = false;
                }).finally(() => {
                    this.formSubmitHideWait(this.$refs.form);
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/Auth/RegisterTenant.vue